import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { yellowMain, black500 } from '../../../constants/color';
import { useState, useRef } from 'react';
import { uploadContainer } from './style';
import { useDropzone } from 'react-dropzone';
import { palette } from '../../../../theme/palette';
const theme = palette('light');
export const UploadMultipleAction = ({ text, h = 173, px = 10, py = 0, onFileUpload, direction = 'col', borderRadius = '25px', variant = 'contained', showMessage = 'no', errorBottom = -10, titleFont = 'default', subtitleFont = 'default', errormsg, multiple = false, maxFiles = 4, actionHeight = h - 20, disabled = false }) => {
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const onDrop = (acceptedFiles) => {
        if (disabled)
            return;
        const combined = [...files, ...acceptedFiles].slice(0, maxFiles);
        setFiles(combined);
        onFileUpload(combined);
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        multiple,
        disabled
    });
    const handleBrowseClick = () => {
        if (disabled)
            return;
        fileInputRef.current?.click();
    };
    const clearFile = (index) => {
        if (disabled)
            return;
        const updated = files.filter((_, i) => i !== index);
        setFiles(updated);
        onFileUpload(updated.length ? updated : null);
    };
    return (_jsxs(Box, { position: 'relative', height: 'auto', children: [_jsxs(Box, { ...getRootProps(), onClick: handleBrowseClick, sx: {
                    height: `${h}px`,
                    px: `${px}px`,
                    py: `${py}px`,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    borderRadius,
                    background: disabled
                        ? '#ECECEC'
                        : isDragActive
                            ? theme.primary.lighter
                            : variant === 'outLined'
                                ? ''
                                : theme.primary.lighter,
                    border: variant === 'outLined' ? '' : `1px dashed ${disabled ? '#CCCCCC' : yellowMain}`,
                    opacity: disabled ? 0.6 : 1,
                    ...uploadContainer
                }, children: [_jsx("input", { ...getInputProps(), type: 'file', multiple: multiple, ref: fileInputRef, disabled: disabled, style: { display: 'none' }, onChange: (e) => {
                            if (disabled)
                                return;
                            const selected = e.target.files ? Array.from(e.target.files) : [];
                            const combined = [...files, ...selected].slice(0, maxFiles);
                            setFiles(combined);
                            onFileUpload(combined);
                        } }), _jsxs(Box, { sx: {
                            ...(direction === 'row'
                                ? {
                                    display: 'flex',
                                    gap: { xs: 2, md: 17 },
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }
                                : {})
                        }, children: [_jsx(Typography, { fontSize: titleFont === 'default' ? (direction === 'row' ? '14px' : '21px') : titleFont, fontWeight: 500, zIndex: 10, color: black500, children: text }), _jsx(Typography, { zIndex: 10, fontSize: subtitleFont === 'default' ? '12px' : subtitleFont, fontWeight: 500, color: theme.primary.dark, children: "Drag & drop file(s) to upload or browse" })] })] }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: -19, left: 5 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, color: '#FF0000', children: errormsg }) }))] }));
};
